import { render, staticRenderFns } from "./DiagnosticosSocioambientais.vue?vue&type=template&id=e3cf0620&lang=pug"
import script from "./DiagnosticosSocioambientais.vue?vue&type=script&lang=js"
export * from "./DiagnosticosSocioambientais.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticosSocioambientais.vue?vue&type=style&index=0&id=e3cf0620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports